export const safeGet = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('localStorage getItem fehlgeschlagen:', e);
      return null;
    }
  };
  
  export const safeSet = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn('localStorage setItem fehlgeschlagen:', e);
    }
  };
  
  export const safeRemove = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn('localStorage removeItem fehlgeschlagen:', e);
    }
  };
  